<template>
  <p class="mb-0">
    <IconCheck class="active" v-if="condition" />
    <IconCloseCircle class="danger" v-else />
  </p>
</template>

<script>
export default {
  props: {
    condition: Boolean
  }
}
</script>
